import { StepModel } from "../../common/components/dotLegalStepper/DotLegalCoreStepper.types";
import { SystemModel } from "../systemEdit/SystemEdit.types";
import { useSteps } from "../../common/components/dotLegalStepper/useSteps";
import { EntityTemplate } from "../../entityTemplates/EntityTemplate.types.ts";
import { getSystemFieldValue } from "../systemEdit/SystemValidator.hooks.ts";
import { hasFieldData } from "../../entityTemplates/fieldValue.ts";

export function useSystemSteps(system: SystemModel | undefined, systemTemplate: EntityTemplate | undefined, systemSteps: Array<StepModel>) {
    system = system ?? new SystemModel();
    const steps = useSteps(system, systemSteps, "step", HasStepDataAdded);

    function HasStepDataAdded(step: number) {
        if (!systemTemplate) {
            return false;
        }
        const templateStep = systemTemplate.steps.find((x) => x.order === step);

        return !!templateStep?.fields.some((field) => hasFieldData(getSystemFieldValue(field, system, [])));
    }

    return {
        getSteps: steps.getTemplateSteps,
        getActiveStep: steps.getActiveStep,
        changeStep: steps.changeStep,
        validationErrors: steps.validationErrors,
    };
}
